import * as React from 'react'
import { FC, useMemo } from 'react'

import { ENTITY_TYPES } from '@sales-center/common'
import { ILead } from '@user/store/lead/typings'
import { IOpportunity } from '@user/store/opportunity/typings'
import { LEAD_STATUSES } from '../Leads/LeadCard/typings'
import { useCheckPermissions } from '@user/store/authorization/permissions'
import { ServiceDialog } from './ServiceDialog'
import { OPPORTUNITY_STATUSES } from '../Opportunities/OpportunityCard/typings'

interface Props {
  detail: ILead | IOpportunity
  entityType: ENTITY_TYPES
  entityStatus: LEAD_STATUSES | OPPORTUNITY_STATUSES
  isOpen: boolean
  onClose: () => void
}

export const ServiceDialogEntityCardWrapper: FC<Props> = (props) => {
  const { detail, entityStatus, entityType, isOpen, onClose } = props

  const [canUpdateLeads, canUpdateOpportunities] = useCheckPermissions(
    'leads_update',
    'opportunities_update',
  )

  const isLead = useMemo(() => {
    return entityType == ENTITY_TYPES.Lead
  }, [entityType])

  const canUpdate = useMemo(() => {
    return isLead ? canUpdateLeads : canUpdateOpportunities
  }, [canUpdateLeads, canUpdateOpportunities, isLead])

  const isClosedOpp = useMemo(() => {
    return (
      entityStatus == OPPORTUNITY_STATUSES.Lost ||
      entityStatus == OPPORTUNITY_STATUSES.Won
    )
  }, [entityStatus])

  const isDisqualifiedLead = useMemo(() => {
    return entityStatus == LEAD_STATUSES.Disqualified
  }, [entityStatus])

  const deleteServiceWarningMessage = useMemo(() => {
    return isLead ? '' : 'Opportunities require at least one product or service'
  }, [isLead])

  const minimumServicesCount = useMemo(() => {
    return isLead ? 0 : 1
  }, [isLead])

  return (
    <ServiceDialog
      address={detail.address}
      branchId={detail.branchId}
      deleteServiceWarningMessage={deleteServiceWarningMessage}
      entityId={detail.id}
      entityType={entityType}
      minimumServicesCount={minimumServicesCount}
      open={isOpen}
      onClose={onClose}
      openAddServiceDrawerOnMount={false}
      readOnly={!canUpdate || isClosedOpp || isDisqualifiedLead}
      locationSource="existing"
      referralDiscountId={detail.referralDiscountId}
    />
  )
}
ServiceDialogEntityCardWrapper.displayName = 'ServiceDialogEntityCardWrapper'
